var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturnIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.7,7.2c2.5,2.1,4.9,4.2,7.5,6.4,2.6-1,5.2-2.1,7.8-3.3,10.8-4.7,23.9-5.1,35.1-1.5,11.3,4.9,20.1,13.7,25,25,3.5,10.9,3.4,24.5-1.2,35-6,10.8-14.9,19.4-26.8,23.2-12.8,2.6-25.9,1.8-37.1-5.2-9.6-6.9-16.1-15.7-18.8-27.3-.3-3.3-.2-6.3,0-9.6h9.6c0,.7.2,1.5.2,2.2,1.4,9.7,4.6,17.7,12.5,23.9,9,6,17.2,7,27.9,6,8.2-2,15.1-6.1,19.8-13.1,5.3-9.3,6.6-19,4.1-29.6-3.7-10-9.4-15.8-19.1-20.3-10.1-3.2-20.8-2.1-30.5,2,1.8,2.5,3.5,4.9,5.3,7.5H15.7V7.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIconCopy);
export default __webpack_public_path__ + "static/media/return-icon-copy.d6ab14eda70f60854ee48ec0dac05a2f.svg";
export { ForwardRef as ReactComponent };